<template>
  <div class="page">
    <div class="title">{{ noticeInfo.title || '标题' }}</div>

    <div class="cover">
      <img v-if="noticeInfo.imgUrl" :src="$FILE_PATH + noticeInfo.imgUrl" width="100%" />
    </div>

    <div class="info">
      <div class="logo">
        <img v-if="noticeInfo.publisherAvatar" :src="$FILE_PATH + noticeInfo.publisherAvatar" />
      </div>
      <div class="content">
        <div class="nickname">{{ noticeInfo.publisherNickname }}</div>
        <div class="detail">发布时间：{{ noticeInfo.createDate }} | 阅读人数：{{ noticeInfo.readNum }}</div>
      </div>
    </div>

    <div class="rich" v-html="noticeInfo.content" />
    <download :scheme="`juqin://?type=notice_detail&noticeId=` + id" />
  </div>
</template>

<script>
export default {
  name: 'TeamAnnouncement',
  data() {
    return {
      id: '',
      noticeInfo: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    async init() {
      const loading = this.$toast.loading({ message: '加载中' })
      await Promise.all([this.getDetail()])
      loading.clear()
    },

    async getDetail() {
      const response = await this.$request.api.get({ url: this.$api.teamNoticeDetailUrl + this.id })
      const { success, message, code, data } = response

      if (success && code === 200) {
        this.noticeInfo = data
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  .title {
    padding: 20px;
    font-size: 42px;
    font-weight: bold;
    text-align: center;
  }

  .cover {
    padding: 0 20px;

    img {
      border-radius: 8px;
    }
  }

  .info {
    display: flex;
    align-items: center;
    padding: 20px 20px;

    .logo {
      padding-right: 10px;

      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;

      .detail {
        color: #888888;
      }
    }
  }

  .rich {
    padding: 0 20px;

    img {
      max-width: 100%;
    }
  }
}
</style>
